export const exportToCsv = (filename, rows, columns) => {
    if (!rows || !rows.length) {
        alert("ไม่มีข้อมูลสำหรับส่งออก");
        return;
    }

    const separator = ',';

    // Header row
    const csvContent = [
        columns.join(separator),
        ...rows.map(row =>
            columns.map(col => {
                let val = row[col] === null || row[col] === undefined ? '' : String(row[col]);
                // Escape quotes
                val = val.replace(/"/g, '""');
                // Quote string if it contains separator, newline, or quotes
                if (val.search(/("|,|\n)/g) >= 0) {
                    val = `"${val}"`;
                }
                return val;
            }).join(separator)
        )
    ].join('\r\n');

    // Add UTF-8 BOM for Excel
    const blob = new Blob(["\uFEFF" + csvContent], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement("a");
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
